import {
  REACT_APP_CONNECT_API_URL,
  REACT_APP_CONNECT_CONFIG_NAME,
  REACT_APP_CONNECT_INSTANCE_ID,
  REACT_APP_CONNECT_INSTANCE_URL,
  REACT_APP_CONNECT_REGION,
} from './envs';
import { ActionPermissions } from '../@types';

// Master kill-switch for the embedded Amazon Connect softphone. When false
// the CCP iframe never initialises — no connection attempts, login popups,
// retries, or tab-leader heartbeat — and every consumer falls back via
// useConnectOptional (sidebar phone panel hides, click-to-dial reverts to
// plain `tel:` links). Currently disabled; flip to true to re-enable.
// Annotated `boolean` (not the inferred literal `false`) so the enabled path
// in ConnectProvider stays type-reachable and re-enabling is a one-line flip.
export const CONNECT_ENABLED: boolean = false;

// Permission gate for the entire softphone surface (sidebar widget, drawer,
// click-to-dial atoms). One permission controls everything per product
// requirements.
export const CONNECT_PERMISSION = ActionPermissions.Service_Calls_Search;

// CCP path is fixed by AWS. The newer `<alias>.my.connect.aws` instance URL
// pattern serves CCP v2 at `/ccp-v2` directly; the legacy
// `<alias>.awsapps.com/connect/` URLs needed a `/connect/` prefix. Defaults
// in envs.ts use the new pattern, so no prefix.
export const CCP_URL = `${REACT_APP_CONNECT_INSTANCE_URL.replace(/\/$/, '')}/ccp-v2`;
export const LOGIN_URL = `${REACT_APP_CONNECT_INSTANCE_URL.replace(/\/$/, '')}/login`;
export const CONNECT_REGION = REACT_APP_CONNECT_REGION;
export const CONNECT_INSTANCE_ID = REACT_APP_CONNECT_INSTANCE_ID;
export const CONNECT_API_URL = REACT_APP_CONNECT_API_URL;
export const CONNECT_CONFIG_NAME = REACT_APP_CONNECT_CONFIG_NAME;

// Default Australian country code for E.164 normalisation. Numbers entered
// without a country code are assumed local.
export const DEFAULT_COUNTRY_CODE = '+61';

// localStorage namespace. Keys are scoped per user (email) by the storage
// helper so two agents on the same workstation never see each other's data.
// Bump the version suffix to invalidate stored shape on schema changes.
export const STORAGE_NAMESPACE = 'v4_connect';

// Cap stored history so localStorage doesn't grow unbounded for power users.
export const HISTORY_LIMIT = 100;

// BroadcastChannel name for cross-tab CCP-active detection. Only one CCP
// session can run per browser; the guard hides duplicate widgets.
export const TAB_GUARD_CHANNEL = 'v4-connect-tab-guard';

// Status display colours. Keys are normalised agent-state types from the
// Streams API (`AgentStateType`). The UI maps unknown states to `default`.
export const STATUS_COLORS = {
  available: '#22c55e', // green-500
  busy: '#f97316', // orange-500
  onCall: '#f97316',
  afterCallWork: '#eab308', // yellow-500
  offline: '#94a3b8', // slate-400
  error: '#ef4444', // red-500
  default: '#94a3b8',
} as const;

export type StatusColorKey = keyof typeof STATUS_COLORS;
